import { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, FormControl, InputLabel, Select, MenuItem, DialogActions, Button } from "@mui/material";
import adminAPI from '../../Services/Admin/adminAPI';

const SubTypeUpdateDialog = ({ open, handleClose, selectedIds }) => {
  const [subType, setSubType] = useState('');

  const subTypeOptions = [
    { value: "", title: "Aucune" },
    { value: "shoulder", title: "Épaule" },
    { value: "humerus", title: "Humérus" },
    { value: "elbow", title: "Coude" },
    { value: "forearm", title: "Avant-bras" },
    { value: "wristhand", title: "Poignet-Main" },
    { value: "back", title: "Rachis" },
    { value: "pelvic", title: "Bassin" },
    { value: "hip", title: "Hanche" },
    { value: "proximalFemur", title: "Fémur proximal" },
    { value: "midFemur", title: "Diaphyse fémorale" },
    { value: "distalFemur", title: "Fémur distal" },
    { value: "knee", title: "Genou" },
    { value: "limb", title: "Jambe" },
    { value: "ankle", title: "Cheville" },
    { value: "foot", title: "Pied" },
  ];

  const handleChangeSubType = (event) => {
    setSubType(event.target.value);
  };

  const handleConfirm = async () => {
    console.log(selectedIds,subType)
    try {
      const response = await adminAPI.updateNomenclatureSubType({
        ids: selectedIds,
        subType
      });
      console.log('Succès:', response.data);
      handleClose(); // Fermer le dialogue après la confirmation
    } catch (error) {
      console.error('Erreur lors de la mise à jour du sous-type:', error);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Modifier le sous-type d'intervention</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel id="subtype-label">Sous-type d'intervention</InputLabel>
          <Select
            labelId="subtype-label"
            id="subtype-select"
            value={subType}
            label="Sous-type d'intervention"
            onChange={handleChangeSubType}
          >
            {subTypeOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.title}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Annuler</Button>
        <Button onClick={handleConfirm} type="submit">Confirmer</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubTypeUpdateDialog;
